import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from "src/app/services/customer.service";
import { AWBService } from "src/app/services/operations/awb.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AppCoreService } from "src/app/services/app-core.service";
import { NgbAccordionToggle, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { VendorService } from "src/app/services/vendor.service";
import { Utilities } from "src/app/models/utilities";
import { UserManagementService } from "src/app/services/user-management.service";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import Swal from "sweetalert2";
import { KycViewComponent } from "./kyc-modal/kyc-view.component";
import { lastValueFrom } from "rxjs";
@Component({
    selector: 'app-tracking',
    templateUrl: './tracking.component.html',
    styleUrls: ['./tracking.component.scss']
})

export class TrackingComponent implements OnInit, AfterViewInit {
    @ViewChild('accordion') accordion: NgbAccordionToggle
    shippingInfoForm: FormGroup;
    additionalInfoForm: FormGroup;
    awbForm: FormGroup;
    shipper: any;
    consignee: any;
    customer: any;
    customerId: any;
    forwardingData: any;
    podData: any;
    isFormSubmitted = false;
    showAwbQuery = false;
    activeIds: any;
    billingtype: any;
    vendorId: number;
    isCustomer = true;
    headerData: any;
    shipmentDetailsData: any;
    awbNumber: string;
    awbData: any;
    podUploadedFileURL: string;
    podUploadedFileName: string;
    isCustomerAdmin = false;
    formFiveCustomerUploadedFileURL: string;
    uploadedDocumentRowData: any[] = [];

    detailPermission = {
        charges: false,
        forwardinginfo: false
    };

    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };

    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;

    defaultColDef = {
        sortable: true,
        resizable: false,
        filter: true
    };

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 5,
        domLayout: 'autoHeight'
    }

    progressColumnDefs = [
        { headerName: 'User Id', field: 'userid' },
        { headerName: 'Date', field: 'transactiondate' },
        { headerName: 'Time', field: 'transactiontime' },
        { headerName: 'Service Center', field: 'servicecenter' },
        { headerName: 'Status Details', field: 'transactionstatus' },
    ];

    commentColumnDefs = [
        { headerName: 'User Id', field: 'userid' },
        { headerName: 'Date Time', field: 'commentdate' },
        {
            headerName: 'Comment',
            field: 'comment',
            autoHeight: true,  // Automatically adjust row height
            cellStyle: {
                whiteSpace: 'normal',  // Wrap text in the cell
                wordWrap: 'break-word'  // Optional: ensures word wrapping
            },
        },
    ];


    shipmentColumnDefs = [
        { headerName: 'User Id', field: 'userid' },
        { headerName: 'Date', field: 'date' },
        { headerName: 'Time', field: 'time' },
        { headerName: 'Message', field: 'message' },
    ];

    volumetricColumnDefs = [
        { headerName: 'Child AWB No', field: 'childawbnumber', pinned: 'left' },
        ...(!this.isCustomer ? [{ headerName: 'Agent AWB No', field: 'date' }] : []),
        { headerName: 'Actual Weight', field: 'piecesactualweight' },
        { headerName: 'Length', field: 'pieceslength' },
        { headerName: 'Width', field: 'piecesbreadth' },
        { headerName: 'Height', field: 'piecesheight' },
        { headerName: 'Volumetric Weight', field: 'piecesvolumetricweight' },
        // { headerName: 'Charge Weight', field: 'pieceschargeableweight' },
        {
            headerName: 'Status', field: 'status', pinned: 'right',
            cellRenderer: Utilities?.status
        },
    ];
    

    itemDetailsColumnDefs = [
        { headerName: 'Box No', field: 'piecescontainerid', maxWidth: 80 },
        // { headerName: 'Package', field: 'date' },
        { headerName: 'Description', field: 'itemdescription' },
        { headerName: 'HSN Code', field: 'itemhsncode', maxWidth: 150 },
        { headerName: 'Quantity', field: 'itemquantity', maxWidth: 100 },
        { headerName: 'Unit', field: 'itemunit', maxWidth: 100 },
        { headerName: 'Rate', field: 'itemrate', maxWidth: 100 },
        { headerName: 'Amount', field: 'itemamount', maxWidth: 120 },
        { headerName: 'Weight', field: 'itemweight', maxWidth: 100 },
    ]

    manifestColumnDefs = [
        { headerName: 'AWB No', field: 'awbnumber', pinned: 'left' },
        { headerName: 'Mani No', field: 'manifestfullno' },
        { headerName: 'Location', field: 'location' },
        { headerName: 'Rec.Date', field: 'manifestdate' },
        { headerName: 'Inscan Location', field: 'inscanlocation' },
        { headerName: 'Remark', field: 'remarks' },
        { headerName: 'Rec.weight', field: 'weight' },
        { headerName: 'Status', field: 'status', pinned: 'right', cellRenderer: Utilities?.status }
    ]

    manifestInscanColumnDefs = [
        { headerName: 'AWB No', field: 'awbnumber' },
        { headerName: 'Mani No', field: 'manifestid' },
        { headerName: 'Location', field: 'servicecentername' },
        { headerName: 'Rec.Date', field: 'shipmentreceiveddate' },
        { headerName: 'Inscan Location', field: 'message' },
        { headerName: 'Remark', field: 'remarks' },
        { headerName: 'Rec.weight', field: 'message' },
    ]

    manifestDetailsColumnDefs = [
        { headerName: 'Manifest No', field: 'userid' },
        { headerName: 'Manifest Date Origin', field: 'date' },
        { headerName: 'Location', field: 'time' },
        { headerName: 'Manifest To', field: 'message' },
        { headerName: 'Vendor', field: 'message' },
        { headerName: 'UserID', field: 'message' },
    ]

    drsDetailsColumnDefs = [
        { headerName: 'AWB No', field: 'awbnumber', pinned: 'left' },
        { headerName: 'DRS No', field: 'drsfullno' },
        { headerName: 'Rec.Date', field: 'drsdate' },
        { headerName: 'Location', field: 'fromlocation' },
        { headerName: 'Status', field: 'status', pinned: 'right', cellRenderer: Utilities?.status },
        // { headerName: 'Courier Boy', field: 'fieldexecutive' },
        // { headerName: 'Mobile No.', field: 'message' },
        // { headerName: 'Service Center', field: 'servicecentername' },
        // { headerName: 'Area', field: 'message' },
        // { headerName: 'UserID', field: 'userid' },
        {
            headerName: 'Actions',
            field: 'fileurl',
            cellRenderer: (params: { value: string }) => {
                if (params.value) {
                    return `<a href="${params.value}" target="_blank">
                                <i class="bx bx-show text-warning me-1 font-size-16"></i>
                            </a>`;
                }
                return 'NA';
            },
            cellClass: "actions-button-cell",
            cellStyle: { "overflow": 'visible' },
            colId: 'params',
            editable: false,
            sortable: false,
            filter: false,
            minWidth: 100,
            pinned: 'right',
        }
    ]

    awbChargesColumnDefs = [
        { headerName: 'Sr No', field: 'userid' },
        { headerName: 'Action Date', field: 'date' },
        { headerName: 'Action Time', field: 'time' },
        { headerName: 'Remark', field: 'message' },
        { headerName: 'Amount', field: 'message' },
        { headerName: 'Type', field: 'message' },
        { headerName: 'Action User', field: 'message' },
    ]

    deliverChargesColumnDefs = [
        { headerName: 'Sr No', field: 'userid' },
        { headerName: 'Action  Date', field: 'date' },
        { headerName: 'Action  Time', field: 'time' },
        { headerName: 'Remark', field: 'userid' },
        { headerName: 'Amount', field: 'message' },
        { headerName: 'Type', field: 'userid' },
        { headerName: 'Action User', field: 'message' },
    ]

    tatDetailsColumnDefs = [
        { headerName: 'Remark', field: 'remark' },
        { headerName: 'Transit Time', field: 'tat' }
    ]

    chargeColumnDefs = [
        { headerName: 'Contract Charges', field: 'contractchargesamount', minWidth: 150 },
        { headerName: 'Other Charges', field: 'otherchargesamount', minWidth: 150 },
        { headerName: 'Sub Total', field: 'subtotal', minWidth: 150 },
        { headerName: 'Total Fuel', field: 'totalfuel', minWidth: 150 },
        { headerName: 'IGST', field: 'igst' },
        { headerName: 'CGST', field: 'cgst' },
        { headerName: 'SGST', field: 'sgst' },
        { headerName: 'Total Amount', field: 'totalamount', minWidth: 150 },
    ]

    chargeDetailsColumnDefs = [
        { headerName: 'Description', field: 'chargesdescription', minWidth: 150 },
        { headerName: 'Amount', field: 'itemamount' },
        {
            headerName: 'Fuel', field: 'isitemfuel',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        { headerName: 'Fuel Amount', field: 'fuelamount' },
        {
            headerName: 'Fuel Tax', field: 'fueltax',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        { headerName: 'Fuel Tax Amount', field: 'fueltaxamount' },
        {
            headerName: 'Tax', field: 'tax',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        {
            headerName: 'IGST', field: 'igst',
            cellRenderer: (params: { data: { tax: boolean; taxes: any; }; }) => {
                return params.data.tax ? params.data.taxes?.tax?.igst : 0;
            }
        },
        {
            headerName: 'CGST', field: 'cgst',
            cellRenderer: (params: { data: { tax: boolean; taxes: any; }; }) => {
                return params.data.tax ? params.data.taxes?.tax?.cgst : 0;
            }
        },
        {
            headerName: 'SGST', field: 'sgst',
            cellRenderer: (params: { data: { tax: boolean; taxes: any; }; }) => {
                return params.data.tax ? params.data.taxes?.tax?.sgst : 0;
            }
        },
        { headerName: 'Total', field: 'itemtotal' },
        {
            headerName: 'Manual', field: 'system',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (!params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        }
    ]
    
    forwardingChargeColumnDefs = [
        { headerName: 'Contract Charges', field: 'contractchargesamount', minWidth: 150 },
        { headerName: 'Other Charges', field: 'otherchargesamount', minWidth: 150 },
        { headerName: 'Sub Total', field: 'subtotal', minWidth: 150 },
        { headerName: 'Total Fuel', field: 'totalfuel', minWidth: 150 },
        { headerName: 'IGST', field: 'igst' },
        { headerName: 'CGST', field: 'cgst' },
        { headerName: 'SGST', field: 'sgst' },
        { headerName: 'Total Amount', field: 'totalamount', minWidth: 150 },
    ]

    forwardingChargeDetailsColumnDefs = [
        { headerName: 'Description', field: 'chargesdescription', minWidth: 150 },
        { headerName: 'Amount', field: 'itemamount' },
        {
            headerName: 'Fuel', field: 'isitemfuel',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        { headerName: 'Fuel Amount', field: 'fuelamount' },
        {
            headerName: 'Fuel Tax', field: 'fueltax',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        { headerName: 'Fuel Tax Amount', field: 'fueltaxamount' },
        {
            headerName: 'Tax', field: 'tax',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        {
            headerName: 'IGST', field: 'igst',
            cellRenderer: (params: { data: { tax: boolean; taxes: any; }; }) => {
                return params.data.tax ? params.data.taxes?.tax?.igst : 0;
            }
        },
        {
            headerName: 'CGST', field: 'cgst',
            cellRenderer: (params: { data: { tax: boolean; taxes: any; }; }) => {
                return params.data.tax ? params.data.taxes?.tax?.cgst : 0;
            }
        },
        {
            headerName: 'SGST', field: 'sgst',
            cellRenderer: (params: { data: { tax: boolean; taxes: any; }; }) => {
                return params.data.tax ? params.data.taxes?.tax?.sgst : 0;
            }
        },
        { headerName: 'Total', field: 'itemtotal' },
        {
            headerName: 'Manual', field: 'system',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (!params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        }
    ]

    uploadedDocumentsColumnDefs = [
        { headerName: 'Title', field: 'title' },
        { headerName: 'File Name', field: 'filename' },
        {
            headerName: 'Action',
            cellRenderer: function (params) {
                return '<a href="' + params.data.domainurl + params.data.filepath + '" target="_blank"><i class="bx bx-download text-success me-1 font-size-16"></i> </a>'
            }
        }
    ]
    kycList = [];
    childAwbRowData: any[] = [];
    progressRowData: any[] = [];
    commentRowData: any[] = [];
    shipmentRowData: any[] = [];
    volumetricRowData: any[] = [];
    itemDetailsRowData: any[] = [];
    manifestRowData: any[] = [];
    //manifestInscanRowData: any[] = [];
    //manifestDetailsRowData: any[] = [];
    drsDetailsRowData: any[] = [];
    tatDetailsRowData: any[] = [];
    //awbRowData: any[] = [];
    //deliveryRowData: any[] = [];
    chargeRowData: any[] = [];
    chargeDetailsRowData: any[] = [];
    forwardingChargeRowData: any[] = [];
    forwardingChargeDetailsRowData: any[] = [];

    awbConfig = {
        isCustomerLoginForwarding2: false
    }
    useEnterKey: any;

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    constructor(
        private awbService: AWBService,
        private formBuilder: FormBuilder,
        private customerService: CustomerService,
        private ngxLoaderService: NgxUiLoaderService,
        public appCoreService: AppCoreService,
        private vendorService: VendorService,
        private route: ActivatedRoute,
        private userManagementService: UserManagementService,
        private configService: ConfigService,
        public utilities: Utilities,
        private titleService: Title,
        private modalService: NgbModal,
    ) {
        titleService.setTitle('Tracking');
        this.context = { componentParent: this }
    }

    ngOnInit(): void {
        this.awbForm = this.formBuilder.group({
            txtAwbNo: [null, Validators.compose([Validators.required])],
        });

        this.shippingInfoForm = this.formBuilder.group({
            transitdetails: this.formBuilder.group({
                txtExpectedDelvDate: [],
                ddlType: []
            })

        });

        this.additionalInfoForm = this.formBuilder.group({
            txtStatus: [false]
        });

        this.getUserData();
        this.shippingInfoForm.get('transitdetails').disable();
        this.getConfigs();

        this.route.params.subscribe(params => {
            const awbnumber = params['awbnumber'];
            if (awbnumber) {
                this.awbForm.get('txtAwbNo').setValue(awbnumber);
                this.bindAwb();
            }
        });

        this.checkPermission();
        if (this.permConfig.isViewAllowed) {
        }
    }

    showPODDocument(){
        this.podUploadedFileURL? window.open(this.podUploadedFileURL, '_blank'): this.appCoreService?.showMessage('No POD available', '', 'error');
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        const permission = userData.config.filter(x => x.categoryname === 'Tracking');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }

        // Tab permissions
        const tabCategories = ['Charges', 'Forwarding Info'];
        const tabPerm = userData.config.filter(x => x.parentcategoryname === 'Operations');
        
        tabCategories.forEach(category => {
            const permission = tabPerm.find(x => x.categoryname === category);
            this.detailPermission[category.replace(/\s+/g, '').toLowerCase()] = permission?.view || false;
        });
    }

    ngAfterViewInit(): void {
        this.utilities.focusFirstElement(this.awbForm)
    }

    getUserData() {
        const data = this.appCoreService.GetUserData();
        this.isCustomer = data.accessType === 'Customer' ? true : false;
        this.userManagementService.GetAllUserGroups({ groupid: data?.groupId }).subscribe((res) => {
            if (res && res.success) {
                let customerAdmin = res.data.find((item: any) => item.name == 'Customer Admin');
                if (customerAdmin && customerAdmin.id === data.groupId) {
                    this.isCustomerAdmin = true;
                }
            }
        })
    }

    bindAwb() {
        this.isFormSubmitted = true;
        this.awbNumber = this.awbForm.get('txtAwbNo').value;
        if (this.awbForm.invalid)
            return;

        if (!this.awbNumber || this.awbNumber == '') {
            this.showAwbQuery = false;
            return;
        }
        this.bindPODFields(this.awbNumber);
        this.ngxLoaderService.start();
        this.awbService.GetByAwbNumber(this.awbNumber).subscribe((res) => {
            if (res && res.success) {
                // console.log("GetByAwbNumber", res?.data);
                this.getConfigs();
                this.bindTracking(res?.data)
            }
            if (res && !res.success) {
                this.ngxLoaderService.stop();
                this.appCoreService.showMessage(res.message, 'info', 'info');
                this.resetForm();
            }
        });
    }

    bindPODFields(awbNumber) {
        if (awbNumber) {
            this.awbService.getPODByAWB(awbNumber).subscribe(res => {
                // console.log(res);
                if (res?.success) {
                    let podDetails = res?.data?.podDetails
                    if (podDetails) {
                        this.podData = {
                            transactionstatus: podDetails?.transactionstatus,
                            remark: podDetails?.additionaldetails?.details?.remark,
                            receiver: podDetails?.additionaldetails?.details?.receiver,
                            telephone: podDetails?.additionaldetails?.details?.telephone,
                            deliverydatetime: this.formateDate(podDetails?.additionaldetails?.details?.deliveryDateTime)?.readableDateTime || '',
                            createddttm: this.utilities.FormatDateWithTime(0, podDetails?.createddttm)?.dateTimeStringAMPM || '',
                        }
                    }
                    else {
                        this.podData = {}
                    }
                }
            });
        }
    }

    bindTracking(data?: any) {
        this.resetForm();
        this.awbData = data;
        // console.log("AwbData", this.awbData);
        const expectedDeliveryDate = this.utilities.FormatDateWithTime(0, data?.shipmentdetails?.expecteddeliverydate)?.dateString;

        const charge = this.awbData?.charges;
        this.chargeRowData.push({
            contractchargesamount: charge?.contractchargesamount,
            otherchargesamount: charge?.otherchargesamount,
            subtotal: charge?.subtotal,
            totalfuel: charge?.totalfuel,
            igst: charge?.taxes?.tax?.igst,
            cgst: charge?.taxes?.tax?.cgst,
            sgst: charge?.taxes?.tax?.sgst,
            totalamount: charge?.totalamount,
        })
        this.chargeDetailsRowData = this.awbData?.charges?.chargesdetails;
        
        const forwardingCharge = this.awbData?.forwardingdetails?.charges;
        this.forwardingChargeRowData.push({
            contractchargesamount: forwardingCharge?.contractchargesamount,
            otherchargesamount: forwardingCharge?.otherchargesamount,
            subtotal: forwardingCharge?.subtotal,
            totalfuel: forwardingCharge?.totalfuel,
            igst: forwardingCharge?.taxes?.tax?.igst,
            cgst: forwardingCharge?.taxes?.tax?.cgst,
            sgst: forwardingCharge?.taxes?.tax?.sgst,
            totalamount: forwardingCharge?.totalamount,
        })
        this.forwardingChargeDetailsRowData = this.awbData?.forwardingdetails?.charges?.chargesdetails;

        this.headerData = {
            awbNumber: data.awbnumber,
            bookingDate: this.utilities.FormatDateWithTime(0, data?.shipmentdetails?.expecteddeliverydate)?.dateString,
            expectedDeliveryDate: expectedDeliveryDate || 'NA',
            origin: data?.details?.filter(item => item.type == 'Shipper')[0]?.origindestloc,
            destination: data?.details?.filter(item => item.type == 'Consignee')[0]?.origindestloc,
        }
        this.shipmentDetailsData = {
            producttype: this.awbData?.producttype,
            product: this.awbData?.productname,
            vendor: this.awbData?.vendorname,
            service: this.awbData?.servicename,
            shipmentvalue: this.awbData?.shipmentvalue,
            pieces: this.awbData?.pieces?.totalpieces,
            actualweight: this.awbData?.pieces?.totalactualweight,
            volumetricweight: this.awbData?.pieces?.totalvolumetricweight
        }

        this.volumetricRowData = data?.pieces?.containers.flatMap(item => {
            if (item.awblist) {
              return item.awblist.map(awb => {
                return {
                  ...item,
                  childawbnumber: awb.awbnumber,
                  status: awb.status ?? data.status // fallback if awb.status is null
                };
              });
            }
            return []; // ensure a flat array
          });
          
        this.itemDetailsRowData = data?.pieces?.containers.map((item) => item?.containeritemsgroup?.subitems).filter(subitems => subitems !== undefined).flat();

        this.shipper = data?.details?.find(x => x.type === 'Shipper');
        this.consignee = data?.details?.find(x => x.type === 'Consignee');
        this.bindCustomer(data?.customerid);
        this.bindForwardingDetails(data?.awbnumber);
        this.bindProgress(data?.childawbnumber ?? data?.awbnumber);
        this.bindComment(data?.awbnumber);
        this.bindManifest(data?.childawbnumber ?? data?.awbnumber);
        //this.bindManifestInscan(data?.awbnumber);
        this.bindDrs(data?.childawbnumber ?? data?.awbnumber);
        this.bindDocument(data?.awbnumber);
        //this.bindTATList(data?.awbnumber);
        if (data) {
            this.showAwbQuery = true;
        }


        if (this.awbNumber.includes('-')) {
            this.volumetricRowData = this.volumetricRowData.filter(item => item?.childawbnumber == this.awbNumber);
            this.itemDetailsRowData = this.itemDetailsRowData.filter(item => item?.piecescontainerid == this.volumetricRowData[0].id);
        }
        // this.getService();
        this.awbForm.reset();
        this.ngxLoaderService.stop();
    }

    // getService() {
    //     this.vendorService.GetAll('').subscribe((res) => {
    //         if (res && res.success) {
    //             this.forwardingData.deliveryvendor = res.data.filter((item) => item.id === this.forwardingData?.deliveryvendor)[0]?.name;
    //             this.forwardingData.vendorname = res.data.filter((item) => item.id === this.vendorId)[0]?.name;
    //             const resData = res?.data[0];
    //             console.log("R", resData);

    //             // this.forwardingDetails.patchValue({
    //             //     txtVendorName: resData?.vendorname,
    //             //     txtDeliveryVendor: resData?.vendorname,
    //             //     txtForwardingAwb: resData?.forwardingawbno,
    //             //     txtDeliveryAwb: resData?.deliveryawbno,
    //             // })
    //         }
    //     })
    // }

    bindForwardingDetails(awbnumber: string) {
        this.awbService.GetForwardingDetailsByAwbNumber(awbnumber).subscribe((res) => {
            if (res && res.success) {
                const resData = res?.data[0];
                this.forwardingData = {
                    vendorname: resData?.vendorname,
                    deliveryvendor: resData?.deliveryvendorname,
                    forwardingawbno: this.awbConfig.isCustomerLoginForwarding2 ? resData?.forwardingawbno : resData?.deliveryawbno,
                    deliveryawbno: resData?.deliveryawbno,
                }
            }
        });
    }

    bindProgress(awbnumber: string) {
        this.awbService.GetProgressByAwbNumber(awbnumber).subscribe((res) => {
            if (res && res.success) {

                const uniqueData = [];
                let seenPartiallyReceived = false;

                res.data.forEach(item => {
                    // Convert transactiondate to Date object
                    if (item.transactionstatus === "SHIPMENT_PARTIALLY_RECEIVED") {
                        if (!seenPartiallyReceived) {
                            seenPartiallyReceived = true;
                            uniqueData.push(item);
                        }
                    } else {
                        uniqueData.push(item);
                    }
                });

                this.progressRowData = uniqueData;
                this.bindAdditionalTAT(this.progressRowData);

                this.headerData.transactionstatus = this.progressRowData[0]?.transactionstatus
                this.awbService.GetChildAwbByAwbNumber(awbnumber).subscribe((res) => {
                    if (res && res.success) {
                        this.childAwbRowData = res.data;
                        if (this.volumetricRowData && this.childAwbRowData?.length) {
                            this.volumetricRowData = this.volumetricRowData.flatMap((item) => {
                                const matchingItem = this.childAwbRowData.find((item2) => item?.childawbnumber === item2?.childawbnumber);
                                if (matchingItem) {
                                    return { ...item, status: matchingItem.status }
                                }
                            });
                        }
                    }
                });

                this.podImage(res.data);
            }
        });
    }

    bindAdditionalTAT(progress: any[]) {
        this.tatDetailsRowData = [];
        progress?.filter(x => x.transactionstatus === 'SHIPMENT_DELAYED')?.map((x: any) => {
            this.tatDetailsRowData.push({
                remark: x?.additionaldetails?.remark,
                tat: `${x?.additionaldetails?.days}d ${x?.additionaldetails?.hours}h`
            });
        });
    }

    bindComment(awbnumber: string) {
        this.awbService.GetCommentByAwbNumber(awbnumber).subscribe((res) => {
            if (res && res.success) {
                // console.log(" res.data : ", res);
                this.commentRowData = res.data.map(x => ({ ...x, commentdate: this.utilities.FormatDateWithTime(0, x.commentdate).dateTimeStringAMPM }));
            }
        });
    }

    bindManifest(awbnumber: string) {
        this.awbService.GetManifestByAwbNumber(awbnumber).subscribe((res) => {
            if (res && res.success) {
                this.manifestRowData = res.data;
            }
        });
    }

    // bindManifestInscan(awbnumber: string) {
    //     this.awbService.GetManifestInscanByAwbNumber(awbnumber).subscribe((res) => {
    //         if (res && res.success) {
    //             this.manifestInscanRowData = res.data;
    //         }
    //     });
    // }

    bindDrs(awbnumber: string) {
        if (awbnumber) {
            this.awbService.GetDrsByAwbNumber(awbnumber).subscribe((res) => {
                if (res && res.success) {
                    this.drsDetailsRowData = res.data;
                }
            });
        }
    }

    bindTATList(awbnumber: string) {
        if (awbnumber) {
            this.awbService.GetTATByAwbnumber(awbnumber).subscribe(res => {
                if (res?.success) {
                    res.data.map(x => {
                        this.tatDetailsRowData.push({
                            id: x.id,
                            remark: x.remark,
                            tat: `${x.tat?.days || 0}d ${x.tat?.hours || 0}h ${x.tat?.minutes || 0}m`
                        });
                    });

                    this.tatDetailsRowData = [...this.tatDetailsRowData];
                }
            });
        }
    }

    bindCustomer(id: any) {
        this.customerService.GetById(id).subscribe((res) => {
            if (res && res.success) {
                this.customer = res.data[0];
                // console.log("Customer", this.customer);
                if (this.customer)
                    this.customer.invoiceno = this.awbData?.invoiceno;
            }
        });
    }

    expandCollapseAll() {
        const Status = this.additionalInfoForm.get('txtStatus').value;
        if (Status) {
            this.activeIds = ['volumetric'];
            // console.log(this.activeIds);
        }
        else {

        }
    }

    formateDate(date?: any) {
        if (date) {
            const inputDate = date != null || undefined ? new Date(date) : new Date();
            const year = inputDate.getFullYear();
            const monthNames = [
                'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
                'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
            ];
            const month = monthNames[inputDate.getMonth()];
            const day = inputDate.getDate().toString().padStart(2, '0');
            const hh = inputDate.getHours();
            const ampm = hh >= 12 ? 'PM' : 'AM';
            const hh12 = (hh % 12) || 12; // Convert to 12-hour format
            const mm = inputDate.getMinutes().toString().padStart(2, '0');

            const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
            const dateString = `${day}-${month}-${year}`;
            const trackingViewDateString = `${day} ${month}, ${year}`;
            const timeString = `${hh12}:${mm} ${ampm}`;
            const readableDateTime = dateString + ' ' + timeString;
            return { dateString, dateTimeString, trackingViewDateString, timeString, readableDateTime };
        }
    }

    getStatusLabel(status: any): string {
        return Utilities.status(status);
    }

    getProgressLabel(status: any, location: string): string {
        return Utilities.progressStat(status, location);
    }

    formatTime(timeString: string): string {
        const inputTime = new Date(`2022-01-01T${timeString}`);

        const hh = inputTime.getHours() % 12 || 12;
        const mm = inputTime.getMinutes().toString().padStart(2, '0');
        const ampm = inputTime.getHours() < 12 ? 'AM' : 'PM';

        return `${hh}:${mm} ${ampm}`;
    }

    resetForm() {
        this.shippingInfoForm.reset();
        this.additionalInfoForm.reset();
        this.customer = null;
        this.customerId = null;
        this.shipper = null;
        this.consignee = null;
        this.showAwbQuery = false;
        this.isFormSubmitted = false;
        this.progressRowData = [];
        this.commentRowData = [];
        this.shipmentRowData = [];
        this.volumetricRowData = [];
        this.itemDetailsRowData = [];
        this.drsDetailsRowData = [];
        this.chargeRowData = [];
        this.chargeDetailsRowData = [];
        this.forwardingChargeRowData = [];
        this.forwardingChargeDetailsRowData = [];
        this.uploadedDocumentRowData = [];
    }

    async bindDocument(awbnumber: string, docType?: string) {
        this.ngxLoaderService.start();
        const res = await lastValueFrom(this.awbService.GetDocumentByAwbNumber(awbnumber, docType));
        if(res){
            this.ngxLoaderService.stop();
            if (res && res.success) {
                if (docType === 'kyc') {
                    this.kycList = res.data;
                } else {
                    this.uploadedDocumentRowData = res.data?.filter(x => x.documenttype == 'otherdocument');
                    let from5Url = res.data?.filter(x => x.documenttype == 'form5');
                    this.formFiveCustomerUploadedFileURL = from5Url[0]?.domainurl + from5Url[0]?.filepath;
                }
            }
        }
    }

    podImage(data) {
        let podData = data.filter(x => x.transactionstatus === 'SHIPMENT_DELIVERED');
        this.podUploadedFileURL = podData[0]?.domainurl && podData[0]?.filepath ? `${podData[0]?.domainurl}${podData[0]?.filepath}` : '';
        this.podUploadedFileName = podData[0]?.filename;
    }

    getConfigs() {
        this.configService.getAllGlobalConfig().subscribe((res) => {
            if (res && res.success) {
                // console.log("res?.data", res?.data);
                this.checkConfig(res?.data.filter(x => x.categoryname == 'AWB'));
            }
        })
    }

    checkConfig(awbconfig: any) {
        // console.log("awbconfig", awbconfig);
        for (let config in awbconfig) {
            switch (awbconfig[config].configurationcode) {
                case 'CUSTOMER_LOGIN_FORWARDING_2':
                    this.awbConfig.isCustomerLoginForwarding2 = awbconfig[config].active;
                    break;
                default:
                    break;
            }
        }
    }

    viewAction(cell: any) {
        try {
            if (!this.permConfig.isEditAllowed) {
                this.errAlert('No Access to Edit.');
                return;
            }
            if (this.permConfig.isEditAllowed && cell?.fileurl) {
                const fileUrl = cell.fileurl;
                const fileExtension = fileUrl.split('.').pop()?.toLowerCase();

                if (['xlsx', 'xls'].includes(fileExtension)) {
                    // Trigger Excel file download
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.download = fileUrl.split('/').pop() || 'file.xlsx';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                else if (['png', 'jpg', 'jpeg', 'svg', 'pdf', 'webp'].includes(fileExtension)) {
                    // Open image in new window
                    window.open(fileUrl, '_blank');
                }
                else {
                    console.warn("Unsupported file type:", fileExtension);
                    this.errAlert(`Unsupported file type:  <b>${fileExtension}</b>`);
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    errAlert(msg: any) {
        Swal.fire({
            titleText: 'Opps!',
            html: msg,
            icon: 'warning',
            confirmButtonText: 'Ok',
        });
    }

    async openKycViewModal() {
        let ngbModalOptions: NgbModalOptions = {
            ariaLabelledBy: 'modal-basic-title',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            centered: true
        };
        await this.bindDocument(this.awbNumber, 'kyc');
        if (!this.kycList.some(x=>x?.concatenated_urlpath)) return this.appCoreService.showMessage('No Kyc Document Attached to view.', '', 'error');
        const modalRef = this.modalService.open(KycViewComponent, ngbModalOptions);
        this.kycList = this.kycList.map(item => ({
            ...item,
            doctype: this.utilities.getFormattedDocType(item.filetype)
        }));

        modalRef.componentInstance.rowData = this.kycList || [];
        modalRef.result.then(
            (result) => {
                if (result) {
                    /* after closing modal */
                }
            },
            (reason) => {
                //on close awb Dialog do nothing
            }
        );
    }

    getPrintType(printType: string) {
        const inputParams = { awbNumber: this.awbNumber, printType: printType };
        this.ngxLoaderService.start();
    
        this.awbService.GeneratePDF(inputParams).subscribe(async (res) => {
            if (res && res.success) {
                this.ngxLoaderService.stop();
                const pdfString = res.data; // Base64 string
                const byteCharacters = atob(pdfString);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
    
                // Create Blob URL
                const pdfUrl = URL.createObjectURL(pdfBlob);
    
                // Open PDF in New Tab
                window.open(pdfUrl, '_blank');
            } else if (res && !res.success) {
                this.ngxLoaderService.stop();
                this.appCoreService.showMessage('No Data Found', '', 'error');
            }
        });
    }
    
}